<template>
  <PageWrapper
    :isLoading="isLoading"
    hasFilters
    @submitFilters="setPageNumberAndSendRequest"
  >
    <template #title> لیست اساتید </template>
    <template #filters>
      <SearchInput
        inputId="fullName"
        inputLabel="نام کاربر"
        inputPlaceholder="علی..."
        v-model.trim="usersListFilter.fullName"
        @enter="setPageNumberAndSendRequest"
      ></SearchInput>
      <SearchInput
        inputId="mobile"
        inputLabel="شماره کاربر"
        inputPlaceholder="0912..."
        v-model.trim="usersListFilter.mobile"
        @enter="setPageNumberAndSendRequest"
      ></SearchInput>
      <SearchInput
        inputId="email"
        inputLabel="ایمیل کاربر"
        inputPlaceholder="info@ferman.org"
        v-model.trim="usersListFilter.email"
        @enter="setPageNumberAndSendRequest"
      ></SearchInput>
      <LanguagePicker
        :placeHolder="`نمایش کاربرانی که برای این زبان رودمپ ندارند`"
        @getLanguage="setRoadmapLanguageId"
        class="w-24 filters-width"
      ></LanguagePicker>
      <CustomDatePicker
        class="w-24 filters-width"
        inputId="createDate"
        @getSelectedDate="setCreateDate"
        inputLabel="تاریخ ایجاد"
        inputPlaceholder="1403/06/05"
      ></CustomDatePicker>
    </template>
    <CustomTable
      v-if="usersList"
      :pageNumber="usersListFilter.pageNumber"
      :count="usersListFilter.count"
      :totalCount="totalCount"
      :tableColumns="tableColumns"
      :tableItems="usersList"
      @changePage="changePage"
    >
      <template #type="data">
        {{ usersTypeEnum[data.item.type] }}
      </template>
      <template #createDate="data">
        {{ new Date(data.item.createDate).toLocaleDateString("fa-IR") }}
      </template>
      <template #actions="data">
        <div class="w-100 d-flex align-items-center" style="gap: 2rem">
          <b-link :to="`/users/${data.item.userId}`">
            <feather-icon class="text-primary" icon="EditIcon" size="20" />
          </b-link>
        </div>
      </template>
    </CustomTable>
  </PageWrapper>
</template>
<script>
export default {
  mounted() {
    if (this.computedPageRouteQuery) {
      this.usersListFilter.pageNumber = this.computedPageRouteQuery;
    } else {
      this.usersListFilter.pageNumber = 1;
    }
    this.getAllUsers();
  },
  data() {
    return {
      isRenderingSalaryModal: false,
      tempMaster: null,
      isLoading: false,
      usersTypeEnum: {
        1: "مدیر کل",
        2: "مدیر زبان",
        3: "مدرس",
        4: "زبان آموز",
        5: "حسابدار",
        6: "پشتیبان",
        7: "بلاگر",
        8: "طراح سوال",
      },
      usersList: null,
      pageNumber: 1,
      count: 10,
      totalCount: null,
      search: null,
      usersListFilter: {
        pageNumber: 1,
        count: 10,
        type: null,
        languageId: null,
        isVipAtLeastOne: null,
        isActiveVip: null,
        vipExpireTimeBigger: null,
        roadMapLangId: null,
        email: null,
        mobile: null,
        createDate: null,
        fullName: null,
        type: 3,
      },
      tableColumns: [
        {
          key: "userId",
          label: "شناسه کاربر",
        },
        {
          key: "fullName",
          label: "نام کاربر",
        },
        {
          key: "mobile",
          label: "شماره همراه",
        },
        {
          key: "type",
          label: "نقش کاربر",
        },
        {
          key: "createDate",
          label: "تاریخ ثبت",
        },
        {
          key: "actions",
          label: "عملیات",
        },
      ],
    };
  },
  methods: {
    setCreateDate(createDate) {
      this.usersListFilter.createDate = new Date(createDate).toISOString();
    },
    setPageNumberAndSendRequest() {
      this.usersListFilter.pageNumber = 1;
      this.setPageNumberQuery(1);
      this.getAllUsers();
    },
    changePage(val) {
      this.usersListFilter.pageNumber = val;
      this.setPageNumberQuery(val);
      this.getAllUsers();
    },
    setPageNumberQuery(pageNumber) {
      this.$router.replace({
        path: this.$route.path,
        query: {
          mastersListPageNumber: pageNumber,
        },
      });
    },
    setRoadmapLanguageId(languageId) {
      this.usersListFilter.roadMapLangId = languageId;
    },
    async getAllUsers() {
      try {
        this.isLoading = true;
        let _this = this;
        let getAllUsersList = new GetAllUsersList(_this);
        getAllUsersList.setRequestParamDataObj(_this.usersListFilter);
        await getAllUsersList.fetch(
          function (response) {
            _this.usersList = response.data.users;
            _this.totalCount = response.data.usersCount;
          },
          function (error) {
            console.error(error);
          }
        );
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },
  },
  computed: {
    computedPageRouteQuery() {
      if (this.$route.query && this.$route.query.mastersListPageNumber) {
        return this.$route.query.mastersListPageNumber;
      }
      return null;
    },
  },
  components: {
    BLink,
    LanguagePicker,
    PageWrapper,
    SearchInput,
    CustomDatePicker,
    CustomTable,
  },
};
import LanguagePicker from "@/views/components/Language/LanguagePicker.vue";

import { BLink } from "bootstrap-vue";
import PageWrapper from "@/views/components/Utils/PageWrapper.vue";
import SearchInput from "@/views/components/Utils/SearchInput.vue";
import CustomTable from "@/views/components/Utils/CustomTable.vue";
import CustomDatePicker from "@/views/components/Utils/CustomDatePicker.vue";
import { GetAllUsersList } from "@/libs/Api/Users";
</script>
